import { request } from '@umijs/max';
import {
  ActionResultData,
  BatchDeletePayload6,
  BatchDisablePayload12,
  BatchEnableBody20,
  BatchHiddenBody19,
  BatchSetOrderInput7,
  BatchShowPayload4,
  PagerDataSysDict,
  SaveTagsBody16,
  SetOrderPayload6,
  SysDict,
  SysDictRequest,
  TagInfo,
  UploadVo,
} from '../AdminTypings';

export namespace AdminSysDict {
  /**
   * @summary 保存数据标签
   * @secure
   */
  export const saveTags = async (
    id: number,
    data: SaveTagsBody16,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/tag/save/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 设置排序权重
   * @secure
   */
  export const setOrder = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    id: number,
    data: SetOrderPayload6,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/set/order/${scene}/${pid}/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 查询列表
   * @secure
   */
  export const query = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: SysDictRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysDict[]>(`/admin/sys/dict/query/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 分页列表
   * @secure
   */
  export const list = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: SysDictRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<PagerDataSysDict>(`/admin/sys/dict/list/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 编辑字典
   * @secure
   */
  export const edit = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    id: number,
    data: SysDict,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/edit/${scene}/${pid}/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 新建字典
   * @secure
   */
  export const create = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: SysDict,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/create/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量显示
   * @secure
   */
  export const batchShow = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: BatchShowPayload4,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/batch/show/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量设置排序权重
   * @secure
   */
  export const batchSetOrder = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: BatchSetOrderInput7,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/batch/set/order/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量隐藏
   * @secure
   */
  export const batchHidden = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: BatchHiddenBody19,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/batch/hidden/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量启用
   * @secure
   */
  export const batchEnable = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: BatchEnableBody20,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/batch/enable/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量禁用
   * @secure
   */
  export const batchDisable = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: BatchDisablePayload12,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/batch/disable/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量删除
   * @secure
   */
  export const batchDelete = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    data: BatchDeletePayload6,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/batch/delete/${scene}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 获取数据可用标签
   * @secure
   */
  export const getTagList = async (id: number, params: { [key: string]: any } = {}) => {
    return request<TagInfo[]>(`/admin/sys/dict/tag/list/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取数据标签
   * @secure
   */
  export const getTags = async (id: number, params: { [key: string]: any } = {}) => {
    return request<string[]>(`/admin/sys/dict/tag/get/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 静态字典数据 [BY ID]
   * @secure
   */
  export const staticDictById = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo>(`/admin/sys/dict/static/by/id/${scene}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 静态字典数据 [BY CODE]
   * @secure
   */
  export const staticDictByCode = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    code: string,
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo>(`/admin/sys/dict/static/by/code/${scene}/${code}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示
   * @secure
   */
  export const show = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/show/${scene}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 字典路径 [BY ID]
   * @secure
   */
  export const dictPathById = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysDict[]>(`/admin/sys/dict/path/by/id/${scene}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 字典路径 [BY CODE]
   * @secure
   */
  export const dictPathByCode = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    code: string,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysDict[]>(`/admin/sys/dict/path/by/code/${scene}/${code}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 字典信息 [BY ID]
   * @secure
   */
  export const dictInfoById = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysDict>(`/admin/sys/dict/info/by/id/${scene}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 字典信息 [BY CODE]
   * @secure
   */
  export const dictInfoByCode = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    code: string,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysDict>(`/admin/sys/dict/info/by/code/${scene}/${code}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 隐藏
   * @secure
   */
  export const hidden = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/hidden/${scene}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 启用
   * @secure
   */
  export const enable = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/enable/${scene}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 禁用
   * @secure
   */
  export const disable = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/disable/${scene}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 详情
   * @secure
   */
  export const detail = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysDict>(`/admin/sys/dict/detail/${scene}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 删除
   * @secure
   */
  export const remove = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/delete/${scene}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 整理数据
   * @secure
   */
  export const collate = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/dict/collate/${scene}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 字典子项 [BY ID]
   * @secure
   */
  export const childrenById = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysDict[]>(`/admin/sys/dict/children/by/id/${scene}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 字典子项 [BY CODE]
   * @secure
   */
  export const childrenByCode = async (
    scene:
      | 'none'
      | 'operation'
      | 'application'
      | 'system'
      | 'cost'
      | 'dynamicCost'
      | 'examine'
      | 'custom'
      | 'dev',
    code: string,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysDict[]>(`/admin/sys/dict/children/by/code/${scene}/${code}`, {
      method: 'GET',
      ...params,
    });
  };
}

export default AdminSysDict;

export const saveTags = AdminSysDict.saveTags;
export const setOrder = AdminSysDict.setOrder;
export const query = AdminSysDict.query;
export const list = AdminSysDict.list;
export const edit = AdminSysDict.edit;
export const create = AdminSysDict.create;
export const batchShow = AdminSysDict.batchShow;
export const batchSetOrder = AdminSysDict.batchSetOrder;
export const batchHidden = AdminSysDict.batchHidden;
export const batchEnable = AdminSysDict.batchEnable;
export const batchDisable = AdminSysDict.batchDisable;
export const batchDelete = AdminSysDict.batchDelete;
export const getTagList = AdminSysDict.getTagList;
export const getTags = AdminSysDict.getTags;
export const staticDictById = AdminSysDict.staticDictById;
export const staticDictByCode = AdminSysDict.staticDictByCode;
export const show = AdminSysDict.show;
export const dictPathById = AdminSysDict.dictPathById;
export const dictPathByCode = AdminSysDict.dictPathByCode;
export const dictInfoById = AdminSysDict.dictInfoById;
export const dictInfoByCode = AdminSysDict.dictInfoByCode;
export const hidden = AdminSysDict.hidden;
export const enable = AdminSysDict.enable;
export const disable = AdminSysDict.disable;
export const detail = AdminSysDict.detail;
export const remove = AdminSysDict.remove;
export const collate = AdminSysDict.collate;
export const childrenById = AdminSysDict.childrenById;
export const childrenByCode = AdminSysDict.childrenByCode;
